<template>
  <div class="tab-bar">
    <van-tabbar v-model="active" active-color="#000" :route="true">
      <van-tabbar-item to="/">
        <span>首页</span>
        <template #icon="props">
          <img :src="props.active ? home.active : home.normal" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="/order" :dot="isRead">
        <span>订单</span>
        <img slot="icon" slot-scope="props" :src="props.active ? order.active : order.normal" />
        <template #icon="props">
          <img :src="props.active ? order.active : order.normal" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="/my">
        <span>我的</span>
        <template #icon="props">
          <img :src="props.active ? my.active : my.normal" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  props: {
    isRead: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  data() {
    return {
      active: 0,
    
      home: {
        normal: require("../assets/tab/home_normal.png"),
        active: require("../assets/tab/home_active.png")
      },
      order: {
        normal: require("../assets/tab/order_normal.png"),
        active: require("../assets/tab/order_active.png")
      },
      my: {
        normal: require("../assets/tab/my_normal.png"),
        active: require("../assets/tab/my_active.png")
      }
    };
  },
  mounted() {
    const CURRENTTABBAR = window.location.pathname;
    // console.log(CURRENTTABBAR)
    if (CURRENTTABBAR == "/") {
      this.active = 0;
    } else if (CURRENTTABBAR == "/order") {
      this.active = 1;
    } else if(CURRENTTABBAR == "/my") {
      this.active = 2;
    }
  }
};
</script>

<style lang="less" scoped>
.van-tabbar{
  height: 108px;
  box-shadow:0px 0px 20px rgba(0,0,0,0.08);
}
.van-tabbar-item__icon img{
  height: 44px;
}
.van-tabbar-item--active{
  .van-tabbar-item__icon img{
    height: 56px;
  }
}
.van-tabbar-item{
  font-size: 24px;
  justify-content: space-around;
  margin: 4px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/tabbar.vue